import { ChangeDetectionStrategy, Component, HostBinding, input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'companyid-social-media',
    imports: [],
    templateUrl: './social-media.component.html',
    styleUrl: './social-media.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialMediaComponent {
    public isDark = input(false, {
        transform: (value: boolean | '') => value === '' || value,
    });
    public svgClassNames = input<string>('');
    public readonly linkedinHref = 'https://linkedin.com/company/companyid-system/';

    @HostBinding('class')
    public readonly hostClassname = 'flex gap-5';
}
